module.exports = __webpack_public_path__ + "img/rename.156141f4.svg";